import { debounce } from "lodash";
import ms from "@sprout/client-lib/dist/ms";
import isPast from "@sprout/client-lib/dist/isPast";
import { formatToTipTapJSON } from "sprout-lib/dist/parser";
export const saveToLocalStorage = debounce((state, cacheKey)=>{
    if (localStorage) localStorage.setItem(cacheKey, JSON.stringify({
        content: state,
        expire: new Date().getTime() + ms.days(1)
    }));
}, ms.seconds(0.5));
export function restoreFromLocalStorage(initialState, cacheKey) {
    const fallbackState = initialState ? formatToTipTapJSON(initialState).json : undefined;
    try {
        if (localStorage) {
            const draft = localStorage.getItem(cacheKey);
            if (draft) {
                const { content , expire  } = JSON.parse(draft);
                if (typeof expire === "number" && isPast(expire)) {
                    localStorage.removeItem(cacheKey);
                    return fallbackState;
                } else if (content) return formatToTipTapJSON(content).json;
            }
        }
        return fallbackState;
    } catch (e) {
        return fallbackState;
    }
}
